module.exports = __webpack_public_path__ + "static/media/FAC-HS- (35) (2)_1611910451179.00c84c9d.jpg";